export default {
  // 可以共用的
  label: {
    description: '简要说明',
    operation_bar: '操作',
    name: '名称',
    title: '标题',
    remind: '请输入%s',
    len: '最多%s字',
    required: '必填',
    export: '导出',
    times: '次',
    sponsor: '发起人',
    approver: '审批人',
    add_success: '新增成功',
    update_success: '更新成功',
    licenseplateNo: '车辆号码',
    shift: '班次',
    company: '企业',
    date: '日期',
    less: '小于',
    greaterOrEqual: '大于等于',
    rmb: '元',
    unitPrice: '单价',
    select: '请选择',
    tips: '提示',
    sort: '排序',
    operation: '操作',
    downloadsuccess: '下载成功',
    please_select: '请选择{title}',
    please_input: '请输入{title}',
    all: '全部',
    yes: '是',
    no: '否',
    remark: '备注',
    constructionsite: '工地',
    earthsite: '土场',
    normal: '正常轨迹',
    plan: '规划线路',
    offset: '偏离轨迹',
    scheduleday: '白班',
    schedulenight: '夜班',
    statusone: '派发中',
    statustwo: '待下发',
    statusthree: '未同步',
    statusfour: '已完成',
    other_statusone: '未呈报',
    other_statustwo: '审批中',
    other_statusthree: '审批通过',
    other_statusfour: '审批不通过',
    sync_success: '同步成功',
    delete_success: '删除成功',
    send_success: '下发成功',
    report_success: '上报成功',
    onekeysync_success: '一键同步成功',
    searchtimerange: '查询时段：',
    filetype_error: '该文件类型不支持',
    upload_success: '上传成功',
    upload_failed: '上传失败',
    createAt: '创建时间',
    creator: '创建人',
    create_success: '创建成功',
    edit_success: '编辑成功',
    score_value: '分值',
    history: '历史记录',
    order_number: '单号',
    placeholder_prefix: '请输入',
    expiredate: '有效期',
    attachment: '附件',
    gcmc: '工地名称',
    tcmc: '土场名称',
    send: '发送',
    alarm: '报警',
    warning: '预警',
    no_data: '暂无相关数据',
    approve_success: '审批成功',
    approve_result: '审批结果',
    agree: '同意',
    refuse: '驳回',
    approve_opinion: '审批意见',
    flow_line: '流水线',
    car_number: '车牌号码',
    forwarding_unit: '发货单位',
    receiving_unit: '收货单位',
    goods_name: '货名',
    card_num: '卡号',
    balance: '余额',
    specifications: '规格',
    weightDeduction: '扣重',
    amountMoney: '金额',
    editedAt: '更新时间',
    vehicle: '辆',
    reportvehiclecount: '上报车辆数',
    sendpeople: '上报人',
    reporttime: '上报时间',
    allselect: '全选',
    common: '共',
    number_car: '辆车',
    abnormal: '异常',
    black: '黑名单',
    fault: '故障',
    offline: '离线',
    outage: '停运',
    unqualified: '不合格',
    operat: '营运',
    selectvehicle: '选择车辆',
    certificate: '证件',
    route: '线路',
    trivelTime: '准运时段',
    number: '数字',
    overflow: '超过',
    limit: '限制',
    success: '成功',
    password: '密码',
    routeInfo: '线路信息',
    add: '添加',
    currencytemp: '默认模板',
    selected: '已选择',
    toward: '至',
    select_btn: '选择',
    start_place: '起点',
    status: '状态',
    unknown: '未知',
    haveinhand: '进行中',
    invalid: '无效',
    template: '模板',
    trackquery: '轨迹查询',
    vehicleDetails: '车辆明细',
    count: '趟数',
    no_info: '暂无数据',
    unlock: '解锁',
    car: '车辆',
    map: '地图选择',
    username: '用户名',
    belong_company: '所属企业',
    download: '下载附件',
    allintegralevent: '全部事件',
    appeal: '申诉',
    tobereview: '待核实',
    eventposition: '事发位置',
    openmap: '查看地图',
    openrule: '查看规则',
    examine: '核实',
    warnScoreMessage: '评分',
    scope: '对象范围',
    end_place: '终点',
    all_above: '所有',
    notstarted: '未开始',
    inforce: '生效中',
    invalid_before: '已失效',
    expired: '已过期',
    enablesuccess: '启用成功',
    outofservicesuccess: '停用成功',
    addrule: '新增规则',
    changescore: '加减分',
    ruleStatus: '规则状态',
    object_type: '对象类型',
    appeal_reason: '申诉理由',
    appeal_status: '申诉状态',
    evaluation_object: '考核对象',
    cycles: '考评周期',
    gradeId: '考评等级',
    event_all: '所有事件',
    event_reduce: '扣分事件',
    event_add: '加分事件',
    confirm_result: '核实结果',
    score: '当前分值',
    record: '考评记录',
    base_score: '基准分值',
    deductpoints: '减分',
    allobject: '所有对象',
    underreview: '核实中',
    partobject: '部分对象',
    applyobject: '适用对象',
    bonuspoints: '加分',
    comment: '考核依据',
    allrule: '全部规则',
    verified: '已核实',
    deductpointsrule: '扣分规则',
    bonuspointsrule: '加分规则',
    process_design: '流程设计',
    savesuccess: '保存成功',
    basic_set: '基础设置',
    edit_type: '编辑类型',
    type_name: '类型名称',
    parallel: '并行',
    name_duplicate: '名称重复',
    details: '明细',
    appeal_set: '申诉设置',
    finish: '流程结束',
    totalScore: '考评总分',
    add_template: '新增模板',
    dynamic_design: '表单设计',
    template_name: '模板名称',
    rule_name: '规则名称',
    rule_type: '规则类型',
    rule_property: '规则属性',
    add_type: '新增类型',
    searchrange: '查询时段',
    disable_rule: '停用规则',
    cert_maxnum: '最大办证数',
    enable_rule: '启用规则',
    viewphotos: '查看图片',
    licenseplateno: '车牌号',
    vehicletype: '车辆类型',
    photoslist: '图片列表',
    reason: '报警原因',
    nophotos: '暂无图片',
    descriptions: '描述',
    change_success: '修改成功',
    close: '关闭',
    open: '开启',
    notification: '通知',
    low: '低',
    mid: '中',
    high: '高',
    confirm: '确认',
    day_before: '前一天',
    day_after: '后一天',
    deviation_rate: '偏移率',
    ranking_count: '车辆数',
    time_success: '设置成功',
    whole_mile: '总里程',
    charts_area: '管辖区',
    mile: '里程',
    family: '家',
    compliance_probability: '合规率',
    unit: '车次',
    out: '出土',
    passageway: '通道',
    submit: '呈报',
    in: '消纳',
    task_name: '任务名称',
    temp_succsss: '暂停成功',
    start_time: '开始时间',
    end_time: '结束时间',
    user: '用户',
    download_path: '路径',
    recover: '恢复',
    task_type: '文件类型',
    submit_task: '呈报任务',
    operate_user: '操作人',
    operate_log: '操作记录',
    process_log: '流程日志',
    operate_time: '操作时间',
    operation_log: '操作日志',
    address: '地点',
    parking: '停车场',
    gas_station: '加油站',
    penalty_zone: '禁区',
    concretesites: '商砼站',
    detailed_address: '详细地址',
    basicInfo: '基本信息',
    fence: '电子围栏',
    draw: '绘制',
    adopt: '通过',
    power: '权限',
    review_opinion: '核实意见',
    object_name: '对象名称',
    pending_approval: '待审批',
    approved: '已审批',
    auto: '自动',
    manual: '手动',
    rule_item: '规则项',
    rule_score: '规则分值',
    alarm_type: '报警类型',
    record_detail: '记录详情',
    curr_power: '当前权限',
    alarm_event: '报警事件',
    system: '系统',
    score_origin: '初始分值',
    color: '分值颜色',
    mark: '颜色标识',
    score_range: '分值范围',
    code_setting: '规则设置',
    operate_type: '操作方式',
    code_color: '颜色标识',
    set: '已设置',
    credible_value: '可信值',
    calculation_object: '计算对象',
    cancel: '已取消',
    warning_name: '预警名称',
    warning_type: '预警分类',
    warning_level: '预警级别',
    handle: '处理',
    will_handle: '待处理',
    handled: '已处理',
    current_object: '当前对象',
    no_adopt: '不通过',
    speed: '速度',
    work_status: '作业状态',
    hydraulic_one: '举升',
    hydraulic_two: '平放',
    flap_one: '关厢',
    flap_two: '开厢',
    isLoad_one: '重载',
    isLoad_two: '空载',
    time: '时间',
    place: '位置',
    projectguid: '项目id',
    application_enterprise: '申请企业',
    drive_license_number: '驾驶证号',
    traffic_police_line: '交警线路',
    check_status: '审核状态',
    check_comment: '审核意见',
    check_unit: '审核单位',
    application_materials: '申请材料',
    passcert_detail: '通行证详情',
    applicant: '申请人',
    passcert_created_time: '通行证创建时间',
    up_loading: '装货',
    down_loading: '卸货',
    rule_uploading: '#装货事件#',
    rule_downloading: '#卸货事件#',
    event_name: '事件名称',
    event_type: '事件类型',
    reliable_score: '可信值分值',
    score_setting: '分值设定',
    bill_rule: '趟数规则',
    reliable_event: '可信值事件',
    site: '场站',
    loading_type: '装卸类型',
    custom_rule: '自定义规则',
    system_rule: '系统规则',
    site_name: '场站名称',
    object_inuse: '应用对象',
    current_bill_rule: '当前趟数规则',
    view_application_object: '查看应用对象',
    select_application_object: '选择应用对象',
    trigger_event: '触发事件',
    please_select_triggerevent: '请选择触发事件',
    threshold_setting: '阈值设置',
    credible_value_threshold: '可信值阈值',
    add_calculated_object: '添加计算对象',
    select_type_tips: '请先选择装卸类型',
    select_type_tip: '请选择装卸类型',
    select_reliable_event: '请选择可信值事件',
    select_application_object_tips: '请选择应用对象',
    open_line: '展开线路',
    close_line: '收起线路',
    travel_time: '准行时段',
    search_station: '请输入工地/土场/停车场/商砼站',
    close_title: '收起',
    open_title: '展开',
    all_have: '共有',
    duration: '持续时间(s)',
    individual: '个',
    handle_time: '确认时间',
    handle_result: '确认结果',
    handler: '确认人',
    create_task_success: '创建导出任务成功',
    repeat_warning: '文件导出任务生成中，请勿重复点击',
    organization_name: '所属组织',
    no_people: '暂无人员',
    app_number: '编号',
    confirm_delete: '确认删除',
    submit_user: '提交人',
    submit_time: '提交时间',
    publish_success: '发布成功',
    confirm_template: '确认是否需要将当前模板进行',
    confirm_template_delete: '删除此模板后已提交的数据会同步删除，您确认要删除吗？',
    template_group: '模板分组',
    is_start: '已启用',
    is_stop: '已停用',
    draft: '草稿',
    publish_time: '发布时间',
    last_edit_time: '最后修改时间',
    add_group: '新增分组',
    group_name: '分组名称',
    please_input_groupname: '请输入分组名称',
    add_group_success: '新增分组成功',
    select_pic: '选择图标',
    select_app_pic: '选择APP图标',
    set_app_pic: '设置APP图标',
    custom_app: '自定义应用',
    select_group: '选择分组',
    device_components: '设备组件',
    finish_all: '已完成/总数',
    task_time_range: '任务时间范围',
    retry_success: '重试成功',
    please_check_data: '请勾选数据',
    please_check_dissuccessData: '请勾选状态是失败的数据',
    batchretry_success: '批量重试成功',
    facilities: '设施',
    dissuccess: '失败',
    issueing: '下发中',
    last_update_time: '最近更新时间',
    file_time_range: '文件时间范围',
    service: '服务器',
    no_file: '暂无文件',
    batch_delete_success: '批量删除成功',
    to_be_upload: '待上传',
    uploading: '上传中',
    can_retry: '可重试',
    can_delete: '可删除',
    option: '项'
    // label
  },
  // 可以共用的
  button: {
    show_cars: '查看车辆',
    show_route: '查看线路',
    create: '新增',
    export: '导出',
    empty: '清空',
    cancel: '取消',
    query: '查询',
    confirm: '确定',
    publish: '发布',
    reset: '重置',
    delete: '删除',
    save: '保存',
    revision: '修改',
    back: '返回',
    search: '搜索',
    setting: '设置',
    edit: '编辑',
    upload: '上传',
    download: '下载',
    attachmentupload: '上传附件',
    look: '查看',
    outofservice: '停用',
    enable: '启用',
    view: '查看详情',
    log: '日志',
    detail: '详情',
    distribute: '保存并派发',
    report: '上报',
    send: '下发',
    sync: '同步',
    onekeysync: '一键同步',
    submit: '保存并呈报',
    approve: '审批',
    operate_all: '批量操作',
    submit_s: '提交',
    stage: '暂存',
    retry: '重试',
    disable: '不启用',
    temp_btn: '暂停',
    refuse: '不同意',
    insert: '插入',
    duration: '持续时间',
    handler: '处理人',
    handle_time: '处理时间',
    handle_result: '处理结果',
    review: '审核',
    reliable_value: '可信值',
    edit_optional: '选填编辑',
    add_by_data: '对照新增',
    upload_file: '上传文件',
    edit_file: '编辑文件',
    add_task: '新增任务',
    file_manage: '文件管理',
    fill_information: '填写信息',
    select_object: '新增对象',
    next_step: '下一步',
    pre_step: '上一步',
    finish: '完成',
    batch_retry: '批量重试',
    refresh: '刷新',
    edit_service: '编辑服务器',
    add_http_service: '新增HTTP服务器',
    add_ftp_service: '新增FTP服务器',
    batch_delete: '批量删除',
    batch_down: '批量下载'
    // button
  },
  // 排班
  worktask: {
    create: '新建排班',
    worktaskdate: '排班日期',
    worktasksend: '排班下发',
    nooptionalreason: '不可选原因',
    treeTransfer_placeholder: '请输入车牌号码(多个用空格分割)',
    log_operatone: '发起调度排班任务',
    log_operattwo: '编辑排班任务',
    log_dailyreport: '编辑日报备任务',
    log_operatthree: '审核排班任务',
    log_operatfour: '车辆上报',
    log_operatfive: '排班下发',
    reportedvehicle: '已上报车辆',
    reportvehicle_common: '上报车辆：共',
    send_finish: '下发完成',
    sended_notsync: '已下发, 未同步',
    needCount: '所需车辆数',
    reportVehicle: '上报车辆',
    createTask: '新建排版任务',
    routefix: '线路修改',
    delete_time: '删除时段',
    warning_address: '当前选择地址有误，请重新点击',
    warning_point: '请先增加上一个线路点',
    warning_delete: '请先增加线路点再执行删除操作',
    warning_task: '请先增加线路点再执行拖拽操作',
    warning_address_drag: '当前拖动地址有误，请重新拖动',
    schedule_route: '排班证线路',
    cert_route: '所属证件线路',
    add_point_tips: '单机左键选择定位点',
    worktask_info: '排班信息',
    reported_notsend: '已上报, 未下发'
  },
  // 电子印章查询
  electronicSeal: {
    system: '电子印章系统',
    pleaseselectsystem: '请选择电子印章系统',
    sealcode: '印章编号',
    pleaseinputsealcode: '请输入印章编号',
    pleaseinputpassword: '请输入密码',
    filename: '电子印章',
    buttontext: '下载印章',
    errormessage: '未查询到对应电子印章，请重新输入'
  },
  // 趟数统计
  countreports: {
    companyName: '运输企业',
    price: '单价(元)',
    counts: '车数/台班/吨数',
    money: '应收/应付款(元)',
    unloadingPrice: '卸土费单价(元)',
    unloadingMoney: '卸土费金额(元)',
    distance: '运距(km)',
    unitPrice: '记效单价(元)',
    vehicleCount: '车数合计',
    billdownload: '单据下载',
    downloadmessagewarn: '单据打印设置为空，请重新设置',
    downloadmessagesuccess: '单据下载完成',
    batchdownloadmessagesuccess: '批量单据下载完成',
    checkmessagewarn: '请勾选车辆趟数明细数据',
    billprintset: '单据打印设置',
    querytime: '查询时间：',
    tabSummary: '趟数汇总统计',
    Details: '车辆趟数明细',
    batchbilldownload: '批量单据下载',
    modaltitle: '选择图片保存路径',
    formlabel: '请选择本地已有磁盘',
    uploadcomptempmsg: '请上传企业模板',
    reupload: '重新上传',
    comptemp: '自定义模板',
    abbreviation: '专用号牌',
    pricingMethod: '计价方式',
    totalPrice: '区间总价',
    priceSetting: '记效单价设置',
    addPrice: '新增价格区间',
    selectCompanyToExport: '请选择需要导出数据的企业',
    priceSettingSuccess: '记效价格设置成功',
    selectCompany: '请先选择企业后再选择需要导出的日期',
    settingFail: '设置失败',
    deletePriceConfirm: '该价格区间删除后会影响趟数统计内的应收/应付金额计算，是否确认删除',
    priceExplain: '说明: xx值以上,可在小于框内输入9999提示',
    attachmentupload: '(最多可上传8个附件，单个附件大小不超过20M)',
    count_log: '趟数日志',
    loading_score: '装货可信值',
    unloading_score: '卸货可信值',
    nodata_tips: '暂无公式数据'
  },
  // 数据字典
  codemanage: {
    stopmsg: '是否停用该码表，确认停用将影响其他拥有该码表的页面功能！',
    startmsg: '是否启用该码表，确认启用将影响其他拥有该码表的页面功能！',
    datadictionary: '数据字典',
    codetype: '码类型{title}',
    parenttitle: '父级{title}',
    codename: '码名称{title}',
    codedescribe: '码描述',
    extendone: '扩展1',
    extendtwo: '扩展2',
    dataclassification: '数据分类：',
    basicconfiguration: '基础配置',
    stationconfiguration: '场站配置',
    equipmentconfiguration: '设备配置',
    editcodetable: '编辑码表'
  },
  // 锁定解锁
  unlock: {
    attempt_times: '尝试次数',
    unlock_time: '锁定时间',
    loginat: '上次登录时间',
    login_ip: '上次登录ip',
    is_locked: '是否锁定',
    edited_at: '更新时间',
    account_name: '账户名称',
    confirm_info: '确定解锁账号',
    success_info: '账号解锁成功'
  },
  // 量化考评
  evaluation: {
    appeal_number: '申诉单号',
    sheet_number: '工单单号',
    list_will_confirm: '待核实列表',
    list_confirmed: '已核实列表',
    filter_score: '分值筛选',
    appeal_confirm: '申诉核实',
    evaluate_score: '审核处理分值',
    belong_area: '所属辖区',
    approved: '核实通过',
    rejectedreview: '核实驳回',
    nocomplaint: '未申诉',
    appealpassed: '申诉通过',
    appealrejected: '申诉驳回',
    transactor: '办理人: ',
    transactor_templary: '考核办理暂存',
    transactor_submit: '考核办理提交',
    transacttime: '办理时间: ',
    addworkorder: '新增考核',
    workorderno: '考核单号',
    assessment_number: '考核单号',
    evaluationevents: '考核事件名称',
    datasources: '数据来源',
    incidenttime: '事发时间',
    evaluationscore: '考核分值',
    workorderstate: '考核状态',
    description: '请输入简要说明，200字以内',
    mapdescription: '请在地图弹框内输入事发位置',
    scoredescription: '当前考评事件分值为空，请重新选择考评事件',
    appealdescription: '请输入申诉理由，200字以内',
    appealwarning: '当前考评记录有更新，请刷新数据！',
    someofrecord: '的考评记录',
    appealsuccess: '申诉提交成功',
    workorderdetail: '考核详情',
    workordersuccess: '考核创建成功',
    workorderexaminestate: '考评核实状态',
    examinereason: '核实理由',
    examinedescription: '请输入核实理由，200字以内',
    createevaluation: '生成考评',
    evaluationexaminepass: '考评核实通过',
    evaluationexaminereject: '考评核实驳回',
    submitappeal: '提交申诉',
    complainants: '申诉人',
    verifier: '核实人',
    testscore: '考评分值',
    verifyreason: '核实意见',
    verifysuccess: '核实提交成功',
    workorderexamine: '考评核实',
    workordermanage: '考评办理',
    success: '申诉核实成功',
    warning_msg: '请选择核实结果',
    waring_comment: '请输入核实意见',
    addevent: '新增考核事件',
    editevent: '编辑事件',
    punishment: '处罚依据',
    pleaseinputeventname: '请输入事件名称，50字以内',
    pleaseselectalarmtype: '请选择报警类型',
    name: '考评项名称',
    objectTypeName: '考评对象类型',
    recordrule: '记分规则：',
    viewobjectrange: '查看考评对象范围',
    objectrangeserachmsg: '请输入要搜索的考评对象',
    pleaseinputname: '请输入考评项名称',
    pleaseselectobjectTypeName: '请选择考评对象类型',
    pleaseselectscope: '请选择对象范围',
    selectapplyobjectmsg: '（选中某个层级则包含其所有子集以及后续新增对象）',
    pleaseselectapplyobject: '请选择适用对象',
    pleaseselectevent: '请选择考评事件',
    scoreFlag: '加减选择',
    pleaseselectscoreFlag: '请选择加减选择',
    scorechange: '分值变化',
    pleaseinputscorechange: '请输入分值变化',
    isReview: '是否需要核实',
    pleaseselectisReview: '请选择是否需要核实',
    isAppeal: '是否可申诉',
    pleaseselectisAppeal: '请选择是否可申诉',
    pleaseselecttime_range: '请选择生效时间范围',
    pleaseinputcomment: '请输入考核依据',
    ruledetails: '考评规则详情',
    check_set: '核实设置',
    custom_appeal: '自定义考评申诉',
    custom_cheack: '自定义考评核实',
    valid_period: '申诉有效期',
    frequency: '申诉次数',
    tips: '核实意见提示',
    set_approver: '设置审批人',
    select_approver: '请选择审批人',
    score_placeholder: '请输入1~9999之间的整数',
    no_complete: '第一步必填项没有填写完全',
    add_parallel: '添加并行',
    parallel_branch: '并行分支',
    complaint_handle_score: '申诉处理分值',
    complaint_details: '申诉详情',
    complaint_alarm_details: '暂无报警详情',
    download_files: '下载卷宗',
    download_error: '下载失败，请先在考评对象管理上传卷宗模板',
    property_incomplete: '组件属性未填写完整',
    upload_template: '上传卷宗模板',
    change_status: '是否{status}{name}考评',
    stop: '停用{name}考评会影响相关考评记录结果查询，是否停用?',
    template_name_placeholder: '请输入模板名称',
    template_delete_title: '确定要删除这条周期考评模板吗',
    template_delete_content: '删除会影响当前考评周期的考评查询，请谨慎操作',
    template_name_warn: '输入内容最多不超过30个字',
    remark_tip: '请输入简要说明,200字以内',
    rule_tamplate_details: '考评规则模板详情',
    stage_success: '暂存成功',
    stage_content: '暂存内容：',
    submit_content: '提交内容：',
    upload_message_f: '最多可上传',
    upload_message_b: '个附件，单个附件大小不超过',
    add_template_warning: '请先启用核实模板或者进行核实模板设置'
  },
  // 规则管理
  rulemanage: {
    car_sealect: '车辆选择规则',
    rule_template: '规则生效模板',
    rule_starttime: '生效开始时间',
    rule_endtime: '生效结束时间',
    rule_belong: '规则归属',
    rule_cert: '生效证件模板',
    time_range: '生效时间范围',
    rule_belong_placeholder: '车辆选择规则',
    rule_name_placeholder: '请输入规则名称',
    cert_maxnum_placeholder: '请输入最大办证数',
    car_max_cert: '车辆最大办证数',
    site_max_cert: '车辆最大办证工地数',
    earthsite_max_cert: '车辆最大办证土场数',
    warning_date: '请输入规则生效时间',
    success_info: '新增规则成功',
    info: '编辑规则成功',
    warning_valid_forbid: '会影响新增证件车辆选择，是否',
    enable_success: '规则启用成功',
    disable_success: '规则停用成功',
    delete_content: '删除会产生如下影响，确认删除？',
    msg1: '1.对已发起的证件将无法查询，建议做好备份',
    msg2: '2.无法在使用该模板发起证件申请',
    success_dele: '删除证件规则成功',
    place_type: '请选择规则类型',
    place_temp: '请选择生效证件模板',
    place_maxnum: '请输入最大办证数',
    max_label: '最大办证数',
    max_label1: '最大办证数',
    max_label3: '最大办证土场数',
    max_label2: '最大办证工地数',
    dele_title: '删除规则',
    dele_success: '删除规则成功',
    dele_content: '删除该规则会影响新增证件，是否删除？',
    dele_rule_tips: '删除规则后应用对象会默认使用系统规则，您确定要删除吗？',
    transfer_tips: '每个对象仅能应用一个趟数规则，对象移入已选确认表示使用当前规则',
    transfer_system_tips: '，使用系统规则的对象不支持取消已选确认',
    transfer_cumtom_tips: '，对象取消已选确认将使用系统趟数规则'
  },
  // 卡口报警
  bayonetalarm: {
    place: '卡口名称',
    capturetime: '抓拍时间',
    crossphoto: '过车图片',
    bayonetposition: '卡口位置',
    exportexcel: '导出Excel',
    nophotoswarn: '该条数据暂无图片'
  },
  // 系统运维-系统配置-其它配置
  otherSetting: {
    change_password: '修改密码',
    name: '配置项名称',
    force_change_pwd: '强制修改初始密码',
    close_wraing: '请确定是否关闭强制修改初始密码,请谨慎操作！',
    open_wraing: '请确定是否开启强制修改初始密码,请谨慎操作！',
    change_error: '修改失败',
    constructionsite_approve: '工地审核配置',
    close_warning: '请确定是否关闭工地审核配置,请谨慎操作！',
    open_warning: '请确定是否开启工地审核配置,请谨慎操作！'
  },
  // 修改密码
  forceChangePwd: {
    success_message: '密码修改成功,请重新登录',
    pwd_warning: '俩次密码输入不一致！',
    pwd_format_err: '密码格式不正确！',
    change_manage_pwd: '修改管控密码',
    change_log_pwd: '修改登录密码',
    pwd_level: '密码强度',
    pwd_notification_one: '-8 - 16个字符，前后不能有空格，区分大小写',
    pwd_notification_two: '-大小写字母、数字、空格及英文符号-=+_.,',
    pwd_notification_three: '-需包含字母、数字及特殊字符两种及以上组合',
    old_pwd: '原密码',
    confirm_old_pwd: '请输入原始密码',
    new_pwd: '新密码',
    confirm_pwd: '确认密码',
    confirm_modal_mes: '是否确认修改登录密码?'
  },
  // 两点一线大数据
  twoPointOneLine: {
    time_warning: '时间设置必须大于0',
    date_warning: '请选择日期',
    carousel_setting: '轮播设置',
    date_carousel: '日期轮播',
    time_carousel: '时间轮播',
    close_carousel: '关闭轮播',
    long_carousel: '轮播时长',
    big_data: '两点一线大数据',
    deviation_mile: '偏移里程',
    charts_name: '偏移率变化趋势',
    whole_city: '全市',
    right_mile: '合规里程',
    offtrack_mileage: '偏移里程',
    off_all_data: '管辖区偏移数据总览',
    city_all_data: '总车辆/企业',
    city_all_workdata: '作业车辆/企业',
    area_inner_data: '区内车辆/企业',
    area_outer_data: '区外车辆/企业',
    company_ranking: '运输企业偏移率排名',
    data_preview: '数据总览',
    date_add_warning: '不可超过当前日期',
    off_track: '偏离线路',
    on_track: '按规划线路行驶'
  },
  // 流量流向大数据
  flowDirection: {
    compliance_probability_preview: '合规出土率总览',
    trashes: '总出土量',
    compliance_trashes: '合规出土量',
    constuctor_count: '作业工地数/办证工地数',
    compliance_number: '合规车次/总车次',
    data_preview: '数据总览',
    constructor_ranking: '工地合规出土率排名',
    open_carousel: '开启轮播',
    big_data: '流量流向大数据',
    compliance_trashes_probability: '合规出土率',
    compliance_trashes_trend: '合规率变化趋势',
    sumtrashes: '总出土',
    sumconsumption: '总消纳',
    thresholdcolor: '阈值颜色'
  },
  // S17视频下载
  videoDownload: {
    temp_tips: '暂停提示',
    confirm_tips: '是否暂停当前视频下载任务',
    waiting_download: '等待下载',
    downloading: '正在下载',
    downloaded: '下载完成',
    download_failed: '下载失败',
    download_suspend: '暂停下载',
    download_local: '本地下载中',
    task_failed: '任务失败',
    file_info: '文件信息',
    download_percent: '下载百分比',
    delete_tips: '删除提示',
    delete_info: '是否删除当前视频下载任务',
    recover_tips: '恢复提示',
    recover_info: '是否恢复当前视频下载任务',
    recover_success: '恢复成功',
    taskname_tips: '请输入任务名称',
    standard_mode: '标准模式(H264/H265)',
    undownload_local: '不下载到本地',
    download_starttime: '下载开始时间',
    download_starttime_tips: '请选择下载开始时间',
    download_endtime: '下载结束时间',
    download_endtime_tips: '请选择下载结束时间',
    download_path_code: '下载路径',
    code_type: '码流类型',
    whole_codeflow: '主码流',
    child_codeflow: '子码流',
    all_codeflow: '所有码流',
    create_success: '创建下载任务成功',
    path_wrong: '路径非法',
    create_task: '新建下载任务',
    tips_error: '创建失败,请检查插件版本',
    repeat_error: '多平台下载视频id重复,暂不支持下载多平台任务'
  },
  // 日报备
  dailyReport: {
    creat_daily_report: '新建日报备',
    date_one: '报备日期',
    report_date_warning: '请选择日报备有效期',
    create_task: '新建日报备任务',
    status: '日报备状态',
    submit_tips: '是否立即呈报给下级部门进行审批',
    schedule_route: '日报备线路',
    success_info: '新增并呈报日报备成功',
    info: '日报备信息',
    submit_info: '呈报日报备任务成功',
    opinion_placeholder: '请输入审批意见',
    approve_task: '审批任务',
    save_approve: '保存并审批',
    submit_confirm: '是否确认呈报任务',
    daily_data: '日报备数据',
    before_operate: '修改前',
    after_operate: '修改后',
    parallel_end: '并行流程结束'
  },
  // map-电子围栏封装
  mapDrawFence: {
    repair_depot: '修理厂',
    speed_area: '限速区-区域',
    speed_line: '限速区-线路',
    cancel_confirm: '确认要取消吗，取消后将不会保存绘制的区域',
    please_draw: '请绘制区域',
    nofence_message: '暂无电子围栏',
    noline_message: '暂无线路',
    map_mousemove_message: '单击点击地图添加点，鼠标双击完成绘制',
    search_message: '请输入区域名称'
  },
  // 工地
  constructionSite: {
    additionalInfo: '补充信息',
    effective_period: '有效时间段',
    have_draw: '(已绘制',
    point: '个点)',
    number: '工地编号',
    abbreviation: '工地简称',
    person_in_charge: '工地负责人',
    principal_phoneno: '负责人联系电话',
    fenceView: '电子围栏查看',
    poi_message: '请输入地点或者在地图上直接选中位置',
    type: '工地类型',
    cargo_name: '货物类型',
    build_company: '建设单位',
    operation_company: '施工单位',
    design_company: '设计单位',
    supervising_company: '监理单位',
    estimation_company: '测算单位',
    internal_transfer: '内转 (m³)',
    external_transfer: '外转 (m³)',
    project_name: '工程类别',
    muck_amount: '工程渣土量',
    waste_amount: '工程建筑垃圾量',
    mud_mount: '泥浆量',
    reporting_capacity: '申报容量 (m³)',
    responsibility: '责任书签订',
    contract_price: '合同价格 (万元)',
    scale: '建设规模 (m³)',
    credentials_no: '证书编号(建设施工许可证号)',
    star_name: '星标',
    fence_tooltip: '请保证经度在前，维度在后，中间用,隔开。多个坐标点之间用“;”隔开，示例:118.121,110.112;118.111,110.112',
    organization_multiname: '请选择所属组织（多选）',
    attachmentupload: '(最多可上传5个附件，单个附件大小不超过5M)',
    build_company_person: '建设单位联系人',
    build_company_phoneno: '建设单位联系人电话',
    build_company_address: '建设单位地址',
    operation_company_person: '施工单位联系人',
    operation_company_phoneno: '施工单位联系人电话',
    operation_company_address: '施工单位地址',
    estimation_company_person: '测算单位联系人',
    estimation_company_phoneno: '测算单位联系人电话',
    estimation_company_address: '测算单位地址',
    fence_draw: '电子围栏绘制',
    fence_draw_input: '绘制坐标区域',
    correct_phoneno: '正确的手机号',
    design_company_person: '设计单位联系人',
    design_company_phoneno: '设计单位联系人电话',
    supervising_company_person: '监理单位联系人',
    supervising_company_phoneno: '监理单位联系人电话'
  },
  // 土场
  earth: {
    type_name: '消纳渣土类型',
    abbreviation: '土场简称',
    capacity: '土场容量 (m³)',
    disposal_type: '土场类型',
    principal: '土场负责人',
    org_name: '监管主体部门',
    number: '土场编号',
    area: '土场面积 (m²)',
    day_ability: '日处理能力 (m³)',
    unloading_price: '卸土费单价 (元)',
    star_name: '关注级别',
    whole_capacity: '总消纳量 (m³)',
    points_limit: '电子围栏点数不能超过300'
  },
  safetyCode: {
    score_tips: '请输入分值',
    range_tips: '请输入有效时间段',
    power_tips: '请选择权限',
    generation_mode: '生成方式',
    discription_tips: '请输入描述',
    color_label: '颜色标识',
    add_record: '增加记录',
    textarea_placeholder: '请输入审批意见，120字以内',
    approve_status: '审批状态',
    approve_reject: '审批拒绝',
    upload_tips: '最多可上传8个附件，单个附件大小不超过20M',
    needApproval: '是否配置审批流程',
    rule_enable_content: '确认是否需要将当前码规则进行',
    rule_disable_content: '确认是否需要将当前码规则进行',
    evaluation: '量化考评',
    automatic_process_settings: '自动流程设置',
    manual_process_settings: '手动流程设置',
    enable_confirm: '确认是否需要将当前码信息进行',
    config: '规则条件',
    add_remind: '当前分值范围区间不能小于20',
    enter_remind: '区间不能小于10',
    select_tips: '请选择权限(多选)',
    code_setting_alarm: '规则设置(报警事件)',
    code_setting_evaluation: '规则设置(量化考评)',
    code_expression: '规则表达式',
    rule_score_warn: '请输入规则分值',
    rule_score_expression: '请输入计算规则',
    ruleitem_warning: '请选择规则项',
    code_rule_name: '安全码规则名称',
    warning_marks: '当前规则颜色标识已被修改',
    operate_type_tips: '安全码标识：对当前对象进行码颜色强制操作，如：直接拉红码（不合格）；规则分值：对当前对象进行一次性扣分/加分操作，如：直接+40分，或直接-40分'
  },
  login: {
    title: '账号登录',
    app: 'APP下载',
    android: '安卓客户端',
    iOS: 'iOS客户端',
    login: '登录',
    support: '技术支持'
  },
  calculator: {
    current_fun: '常用函数',
    validate_success: '校验成功',
    validate: '公式校验',
    symbol: '运算符号',
    insert_fun: '插入函数',
    tips: "请在''内输入文本",
    grammer: '语法',
    // IF
    if_a: '用以进行条件判断函数，使用方法同EXCEL IF函数一致',
    if_c: 'IF ( 判断条件,“是”的结果, “否”的结果 )',
    if_d: '判断条件: 任意表达式，结果可以被计算为“是”或“否”',
    if_e: '“是”的结果: 如果判断结果为“是”，范围的结果',
    if_f: '“否”的结果: 如果判断结果为“否”，返回的结果',
    // AND
    and_a: '检查是否所有参数均为 TRUE，如果所有参数值均为 TRUE，则返回 TRUE',
    and_b: 'AND(逻辑表达式1,逻辑表达式2,......)',
    and_c: '逻辑表达式1：逻辑运算表达式，如 #应发工资#>3500',
    and_d: '逻辑表达式2：逻辑运算表达式，如 #应发工资#>3500',
    // OR
    or_a: '检查是否所有参数均为 FALSE，如果所有参数值均为 FALSE，则返回 FALSE',
    or_b: 'OR(逻辑表达式1,逻辑表达式2,......)',
    or_c: '逻辑表达式1：逻辑运算表达式，如 #应发工资#>3500',
    or_d: '逻辑表达式2：逻辑运算表达式，如 #应发工资#>3500',
    // MIN
    min_a: '返回一组数值中的最小值',
    min_b: 'MIN( 数值1,数值2,···)',
    // MAX
    max_a: '返回一组数值中的最大值',
    max_b: 'MAX( 数值1,数值2,···)'
  },
  exportfile: { // 文件导出任务
    menuName: '所属模块',
    status: '任务状态',
    progress: '导出进度',
    detail: '任务详情',
    wait: '待执行',
    in: '执行中',
    success: '执行成功',
    fail: '执行失败'
  },
  // 车辆预警页面
  vehicleWarning: {
    warning_speed: '预警速度',
    warning_time: '预警时间',
    warning_place: '预警位置'
  },
  // 预警设置页面
  warningSetting: {
    warning_setting: '预警设置',
    warning_attention: '关注与订阅',
    warning_object: '预警对象',
    warning_level: '报警级别',
    warning_switch: '预警开关',
    warning_tip: '当前账号没有权限查看！',
    attention: '关注',
    subscribe: '订阅',
    warning_ring: '预警铃声',
    warning_ring_tip: '（前台接受到预警消息后将发出警报提示音）',
    warning_pop: '预警提醒',
    warning_pop_tip: '（接收到预警消息后将在预警大屏自动弹出预警处理框）',
    warning_cycle: '实时风险情况周期',
    warning_cycle_tip: '（预警大屏的实时风险模块将根据所设的时段进行数据统计）',
    screen_title: '大屏标题',
    minute: '分钟',
    screen_setting: '预警大屏设置',
    error_tip: '请选择智能语音干预或人工干预的预警方式',
    rule_setting_success: '预警规则设置成功',
    spped_percent: '预警时速设定',
    spped_percent_tip: '根据所在道路最大限速值，设定预警时速阈值百分比',
    delay: '持续时长',
    second: '秒',
    system_enable: '智能语音干预',
    system_enable_tip: '车辆触发预警时，系统将自动下发语音文本提醒',
    system_message: '语音提示内容',
    system_message_tip: '提示内容不能为空',
    manual_enable: '人工干预',
    manual_enable_tip: '车辆触发预警次数达到设定阈值及以上时，生成人工干预事件',
    condition_type: '预警条件',
    condition_type_tip: '预警条件不能为空',
    condition_number: '次数条件',
    order: '次',
    title: '实时预警看板',
    reset_success: '重置成功',
    warning_btn_tip: '当前账号没有权限设置！'
  },
  driver: {
    add: '添加驾驶员',
    number: '序号',
    name: '姓名',
    phone: '手机号',
    idcard: '身份证号',
    driver_type: '驾驶员类型',
    car_type: '准驾车型',
    first_date: '初次领证日期',
    been: '驾龄',
    driver_info: '驾驶信息',
    occupational_info: '从业资格信息',
    add_success: '驾驶员新增成功',
    edit_success: '驾驶员编辑成功',
    sex: '性别',
    phone_error: '手机号格式不正确',
    idcard_error: '身份证号格式不正确',
    birthday: '出生年月',
    identity_attachment: '身份证照片（正反面）',
    face_attachment: '人脸照片',
    healthy_attachment: '健康证明',
    license_attachment: '驾驶证照片（主副页）',
    seniority_attachment: '从业资格证',
    safe_attachment: '机动车驾驶员安全信用表',
    year: '年',
    license_validate: '驾驶证有效期',
    license_number: '驾驶证档案编号',
    tobe_submitted: '待提交',
    tobe_reviewed: '待审核',
    reviewed_agree: '审核通过',
    reviewed_disagree: '审核拒绝',
    delete_confirm: '删除确认',
    delete_msg: '确定删除该驾驶员信息吗？',
    reviewed_success: '审核成功',
    last_edit_time: '最近一次修改时间：'
  },
  // 企业大屏
  enterpriseScreen: {
    handle_success: '处理成功',
    event_past_tip: '当前事件已失效',
    event_nofound: '没有找到该事件，请点击重试',
    vehicle_offline_tip: '当前车辆已离线',
    online_car: '在线车辆',
    wait_handle_prealarm: '待处理预警',
    wait_handle_alarm: '待处理报警',
    loading: '载入中...',
    overview: '立即查看',
    mileage: '行驶里程(公里)',
    online_time: '在线时长(分钟)',
    risk: '风险指数',
    voice: '语音提醒',
    call: '实时对讲',
    continuous_alarm: '连续预警',
    minute: '分',
    second: '秒',
    show_alarm_event: '出现报警事件',
    show_prealarm_event: '出现预警事件',
    finish: '处理完成',
    close: '关闭对话',
    voice_fail: '语音发送失败',
    voice_remind: '语音提醒',
    send_frequently: '发送太频繁',
    risk_profile: '风险情况',
    pending_risks: '待处理风险',
    more_warning_list: '更多报警记录',
    more_alarm_list: '更多预警记录',
    warning_car: '预警车辆',
    alarm_count: '报警数量',
    intervene_count: '干预数量',
    data_comparison: '当天数据对比',
    hundred_warning_count: '百公里预警数',
    hundred_alarm_count: '百公里报警数',
    hundred_security_profile: '百公里安全情况',
    hundred_security_point: '百公里安全分数',
    hundred_security_title: '每百公里的安全行驶评分情况，分值越低，出现风险越高。'
  },
  // 核准证
  certificate: {
    certpath: '证书路径',
    projectname: '项目名称',
    gcdz: '工程地址',
    certrowguid: '证书序号',
    applyerName: '核准证申请企业名称',
    zzh: '号',
    cliengguidurl: '附件地址',
    jsdw: '建设单位',
    sgdw: '施工单位',
    ysdw: '运输单位',
    certnum: '证书号',
    zzhn: '年',
    time: '查询时间'
  },
  // 过磅统计
  weighStatistic: {
    gross_weight: '毛重/kg',
    tare_weight: '皮重/kg',
    net_weight: '净重/kg',
    real_weight: '实重/kg',
    grossWeightAt: '毛重时间',
    tareWeightAt: '皮重时间',
    leaveFactoryAt: '出厂时间',
    weighingFee: '过磅费',
    grossWeightUser: '毛重司磅员',
    grossWeightNo: '毛重磅号',
    tareWeightUser: '皮重司磅员',
    tareWeightNo: '皮重磅号',
    editedUser: '更新人',
    pictureList: '过磅图片',
    weigh_query_statistic: '过磅称重查询统计',
    weigh_site: '过磅场站'
  },
  // 空页面
  emptyPage: {
    title_one: '没有符合条件的记录',
    title_two: '请修改条件重新查询'
  },
  // 报警详情
  alarmDetails: {
    alarm_track: '报警追踪',
    car_cert: '车辆证件',
    line_cert: '线路证件'
  },
  // 用户操作日志
  operationLog: {
    created_user_name: '操作用户',
    type: '操作类型',
    content: '操作内容',
    source: '来源'
  },
  // 应用任务
  appTask: {
    status: '已审待审',
    approve_done: '审批完成',
    confirm_tips: '删除此条记录后不可恢复，您确认要删除吗？',
    query_error: '详情权限查询失败',
    site_detail: '工地详情',
    earth_detail: '土场详情',
    no_detail: '暂无详情',
    map_tips: '请在地图弹框内输入',
    tele_warning: '请填写正确的手机或固话号码',
    vehicle_warning: '请填写正确的车牌号码',
    required_warning: '请填写必填项',
    add_success: '新建成功',
    upload_tips_1: '最多可上传',
    upload_tips_2: '个附件，单个附件大小不超过20M',
    approve_warning: '暂无待审批的应用任务',
    next_approver: '下级审批'
  },
  realtimeLog: {
    teminal_upload: '上行',
    station_export: '下行',
    info_time: '通讯时间',
    message_id: '消息ID',
    message_type: '消息类型',
    message_content: '消息内容',
    select_objects: '选择监控对象',
    edit_objects: '编辑监控对象',
    thrity_min: '30分钟',
    one_hour: '1小时',
    auto_refresh: '自动刷新',
    tips: '最多仅支持同时监控10个对象'
  },
  // 远程诊断 远程下发
  teleDiagnosis: {
    deviceFileType_delete_message: '删除当前文件类型后，未完成的相关任务将失败，您确定要删除？',
    deviceFileType_code: '文件编号',
    deviceFileType_name: '文件类型名称',
    deviceFileType_add: '新增文件类型',
    deviceFileType_edit: '编辑文件类型',
    terminalFileDown_filedelete_message: '删除文件后平台未下发文件到终端的任务将失败，您确定要删除文件？',
    terminalFileDown_file_createdAt: '上传时间',
    terminalFileDown_file_name: '文件名称',
    terminalFileDown_file_size: '文件大小',
    terminalFileDown_delete_message: '删除任务后平台未下发文件到终端的任务将停止，您确定要删除任务？',
    terminalFileDown_add: '新增终端文件下发任务',
    terminalFileDownDetail_retry: '将重新下发文件到终端，您确认重试？',
    terminalFileUpload_delete_message: '删除任务后终端上传的文件将删除，您确定要删除任务？',
    service_name: '服务器名称',
    service_address: '服务器地址',
    service_port: '服务器端口',
    terminalFileUpload_add: '新建终端文件上传任务',
    terminalFileUploadDetail_retry: '将重新下发指令到终端上传文件，您确认重试？',
    terminalUploadFile: '终端上传文件',
    terminalFileUploadDetail_delete_message: '删除后已下载的文件也将删除，您确认删除？'
  }
}
